import { FormFieldType } from '@betterfunnel/types';
import {
  CalendarIcon,
  DevicePhoneMobileIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  FlagIcon,
  PhotoIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';
import {
  Bars3Icon,
  EyeSlashIcon,
  HashtagIcon,
} from '@heroicons/react/24/solid';

export const getFormFieldTypeLabel = (type: FormFieldType) => {
  switch (type) {
    case 'email':
      return 'Email';

    case 'tel':
      return 'Phone';

    case 'text':
      return 'Text';

    case 'textArea':
      return 'Text area';

    case 'businessEmail':
      return 'Business email';

    case 'country':
      return 'Country';

    case 'state':
      return 'State';

    case 'number':
      return 'Number';

    case 'select':
      return 'Select';

    case 'hidden':
      return 'Hidden';

    case 'pictureChoice':
      return 'Picture choice';

    case 'consent':
      return 'Consent';

    case 'multiChoice':
      return 'Multi choice';

    case 'date':
      return 'Date';
  }
};

export const getFormFieldTypeIcon = (type: FormFieldType) => {
  switch (type) {
    case 'email':
      return <EnvelopeIcon className="h-4 w-4" />;

    case 'tel':
      return <DevicePhoneMobileIcon className="h-4 w-4" />;

    case 'text':
      return <DocumentTextIcon className="h-4 w-4" />;

    case 'textArea':
      return <DocumentTextIcon className="h-4 w-4" />;

    case 'businessEmail':
      return <EnvelopeIcon className="h-4 w-4" />;

    case 'country':
      return <FlagIcon className="h-4 w-4" />;

    case 'state':
      return <FlagIcon className="h-4 w-4" />;

    case 'number':
      return <HashtagIcon className="h-4 w-4" />;

    case 'select':
      return <Bars3Icon className="h-4 w-4" />;

    case 'hidden':
      return <EyeSlashIcon className="h-4 w-4" />;

    case 'pictureChoice':
      return <PhotoIcon className="h-4 w-4" />;

    case 'consent':
      return <ShieldCheckIcon className="h-4 w-4" />;

    case 'multiChoice':
      return <Bars3Icon className="h-4 w-4" />;

    case 'date':
      return <CalendarIcon className="h-4 w-4" />;
  }
};
